// src/pages/orders/Orders.jsx
import React from "react";
import WrapperSection from "../../components/global/WrapperSection";
import GlobalBreadcrumbs from "../../components/global/GlobalBreadcrumbs";
import OrdersTable from "../../components/orders/OrdersTable";

const Orders = () => {
    return (
        <WrapperSection>
            <GlobalBreadcrumbs />
            <OrdersTable />
        </WrapperSection>
    );
};

export default Orders;
